import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";

const CreateButton = ({ children, url, toggle = () => null }) => {
  return (
    <>
      {url ? (
        <Link to={url}>
          <Button
            color="success"
            className="float-right"
            style={{ minWidth: "200px" }}
          >
            {" "}
            <PlusCircle />
            {children}
          </Button>
        </Link>
      ) : (
        <Button
          color="success"
          className="float-right"
          onClick={() => toggle()}
          style={{ minWidth: "200px" }}
        >
          <PlusCircle />
          {children}
        </Button>
      )}
    </>
  );
};

export default CreateButton;
